module.exports = __webpack_public_path__ + "img/delete-modal.4dbce2a8.png";